import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import {
  GameModalLayout,
  EvaluationComponent,
  useWindowDimensions,
} from "../common";
import { checkGameStatus } from "../../service/logic";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { getOptions } from "../../service/api/option";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { fontSize } from "../../styles";
import { useSelector } from "react-redux";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Markup } from "interweave";
import { AnswerLinkPopup } from "../common/answer-link-popup";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  navbar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  navigate: {
    textTransform: "unset !important",
    textAlign: "center",
    width: "48%",
    height: 50,
    borderRadius: "50",
    marginBottom: 10,
  },
  whole: {
    marginBottom: 10,
  },
  summaryButton: {
    textTransform: "none",
    backgroundColor: "#e50000",
    borderRadius: 20,
    height: 40,
    color: "white",
    whiteSpace: "nowrap",
  },
  summary: {
    marginRight: "40px",
    [theme.breakpoints.down("xs")]: {
      marginRight: "0px",
    },
  },
  contents: {
    marginTop: -10,
    overflowY: "auto",
    minHeight: 340,
  },
}));

const ExamEvaluation = () => {
  const classes = useStyles();
  const [active, setActive] = useState("Evaluation");
  const { examinationSummary } = useSelector((state) => state.gameStates.case);
  const { height } = useWindowDimensions();
  const theme = useTheme();
  const isWidthSm = useMediaQuery(theme.breakpoints.down("xs"));
  const [systemList, setSystemList] = useState([]);

  // helper function to identify examination with subsystems
  const systemsToLocalSystems = (systems) => {
    const tmp = JSON.parse(JSON.stringify(systems));
    const subsystemMap = {}; // to process the parent system - subsystem name
    // find all the subsystems
    tmp.forEach((x) => {
      x.subsystems = systems
        .filter((s) => s.dependent === x.id)
        .map((sub) => ({
          id: sub.id,
          optionId: sub.id,
          name: sub.name,
        }));
      // add into subsystem map for processing later
      x.subsystems.forEach((ss) => (subsystemMap[ss.id] = x.name));
    });
    // for each system, modify name if is subsystem
    tmp.forEach((x) => {
      if (!!subsystemMap[x.id]) {
        x.name = subsystemMap[x.id] + " - " + x.name;
      }
    });
    // reformat all the systems
    return tmp.map((t) => ({
      id: t.id,
      optionId: t.id,
      name: t.name,
      subsystems: t.subsystems,
    }));
  };

  useEffect(() => {
    // check if user is allowed to enter presentation page
    if (!checkGameStatus(GAME_STAGE.EXAMINATION_EVALUATION)) {
      // if not allowed, navigate to case list page
      history.push("/cases");
    }
    // fetch the systems can convert into appropriate system list
    getOptions("examSystem").then((systems) => {
      setSystemList(
        systemsToLocalSystems(systems).filter((s) => s.subsystems.length === 0)
      );
    });
  }, []);

  const handleChange = (event, newValue) => {
    setActive(newValue);
  };
  const summary = () => {
    const { contents, link } = examinationSummary;
    return (
      <div className={classes.summary}>
        <div className={classes.contents} style={{ maxHeight: height - 240 }}>
          <Markup content={contents} />
        </div>
        <AnswerLinkPopup linkArray={link} />
      </div>
    );
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <GameModalLayout
        full
        left={
          <div className={classes.whole}>
            <div className={classes.navbar}>
              <Tabs
                style={{ width: "50%" }}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                value={active}
              >
                <Tab
                  style={{
                    textTransform: "none",
                    fontSize: fontSize.h3,
                    fontStyle: "bold",
                    color: "black",
                  }}
                  label={active}
                  value={active}
                />
              </Tabs>
              <Button
                variant="contained"
                className={classes.summaryButton}
                style={{
                  marginRight: isWidthSm ? -5 : 65,
                  backgroundColor:
                    active !== "Evaluation" ? "#1D3557" : "#e50000",
                }}
                onClick={(e) => {
                  active === "Summary"
                    ? handleChange(e, "Evaluation")
                    : handleChange(e, "Summary");
                }}
              >
                {active === "Summary"
                  ? "Back to Evaluation"
                  : isWidthSm
                  ? "Check Summary"
                  : "Check Exam Summary"}
              </Button>
            </div>
            <div style={{ marginTop: 5 }}>
              {active === "Summary" ? (
                summary()
              ) : (
                <EvaluationComponent
                  parent={systemList}
                  parentID={"system"}
                  parentTitle={"System"}
                  childID={"type"}
                  childTitle={"Body Parts"}
                  getOpChildID="examType"
                  getResultType={"examination"}
                  childText={"sign"}
                />
              )}
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

export default ExamEvaluation;
